<template>

	    <div class="row" v-show="modalita == 1">
			<div class="col-5 col-lg-2 mb-1"> 
	            <label class="form-label text-danger mb-1">Sesso:</label>
				<select class="form-select form-select-sm select-icons" v-model="persona.SESSO" :tabindex="3"> 
					<option value="" data-icon="chrome" selected="selected">Seleziona</option>
					<option value="1"> - Uomo</option>
					<option value="2"> - Donna</option>
				</select> 
			</div>
	        <div class="col-12 col-lg-5 mb-1"> 
				<label class="form-label text-danger mb-1">Cognome:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-user fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.COGNOME" :tabindex="4">
				</div>
	        </div>
	        <div class="col-12 col-lg-5 mb-1">
				<label class="form-label text-danger mb-1">Nome:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-user fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.NOME" :tabindex="5">
				</div>               
	    	</div>
		
	        <div class="col-6 col-lg-4 mb-1">
	            <label class="form-label text-danger mb-1">Nazionalit&agrave;:</label>
	         	<Select2 v-model="persona.FK_ID_NAZIONALITA" :w="250" :api="'core/geo/stati/select2'" :apiselected="'core/basic/element?className=Stato&ID=ID_STATO&DESCRIZIONE=NOME&select2=1'" ::tabindex="2"></Select2>
	        </div>
			<div class="col-6 col-lg-4 mb-1">
	            <label class="form-label text-danger mb-1">Nato a:</label>
				<Select2 v-show="persona.FK_ID_NAZIONALITA == 118" @selected-item="setCap($event)" v-model="persona.FK_ID_COMUNE_NASCITA" :w="250" :api="'core/geo/comuni/select2'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'" :tabindex="6"></Select2>   
				<input v-show="persona.FK_ID_NAZIONALITA != 118" autocomplete="off" type="text" v-model="persona.DESCR_COMUNE_NASCITA" class="form-control form-control-sm" placeholder="Comune nascita" :tabindex="2">                                                                                                                
	        </div>      
	        <div class="col-6 col-lg-4 mb-1">
	            <label class="form-label text-danger mb-1">In Data:</label>
                <VueDatePicker v-model="persona.DATA_NASCITA" model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']" :tabindex="7"></VueDatePicker>
	        </div>	
		
			<div class="col-6 col-lg-3 mb-1">
	            <label class="form-label text-danger mb-1">Residente:</label>
	            <select class="form-select form-select-sm" data-placeholder="Residente" v-model="persona.FLG_RESIDENTE_ITALIA" :tabindex="8">
	                <option value="1">Italia</option>
	                <option value="0">Estero</option>
	            </select>
	        </div>	
	        <div class="col-12 col-lg-6 mb-1">
	            <label class="form-label text-danger mb-1">Indirizzo:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-directions fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.INDIRIZZO" :tabindex="10">
				</div> 				
	        </div>
	        <div class="col-5 col-lg-3 mb-1">
	            <label class="form-label text-danger mb-1">Civico:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-sort-numeric-up-alt fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.CIVICO" :tabindex="11">
				</div> 		            
	        </div>  
		
	        <div class="col-7 col-lg-4 mb-1">
	            <label class="form-label text-danger mb-1">Citt&agrave;:</label>				
				<Select2 v-show="persona.FLG_RESIDENTE_ITALIA == 1" @selected-item="handlerChangeResidenza($event)" v-model="persona.FK_ID_COMUNE" :w="250" :api="'core/geo/comuni/select2'" :apiselected="'core/basic/element?className=Comune&ID=ID_COMUNE&DESCRIZIONE=NOME&select2=1'" ::tabindex="9"></Select2>
				<input v-show="persona.FLG_RESIDENTE_ITALIA != 1" autocomplete="off" type="text" v-model="persona.COMUNE" class="form-control form-control-sm" placeholder="Comune nascita" :tabindex="2">
	        </div>
	        <div class="col-6 col-lg-3 mb-1">
	            <label class="form-label text-danger mb-1">Cap:</label>	
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-qrcode fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.CAP" :tabindex="12">
				</div> 	            
	        </div>
	        <div class="col-6 col-lg-2 mb-1">
	            <label class="form-label text-danger mb-1">Provincia:</label>	
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-map-pin fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" :disabled="persona.FLG_RESIDENTE_ITALIA == 1" v-model="persona.PROV" :tabindex="13">
				</div> 	 	                                                                          
	        </div>
	        <div class="col-12 col-lg-3 mb-1">
	            <label class="form-label text-danger mb-1">Cellulare:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-phone fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.TELEFONO" :tabindex="15">
				</div> 	        	
	        </div>
				
	        <div class="col-12 col-lg-4 mb-1">
	            <label class="form-label text-danger mb-1">Email:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-envelope fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.EMAIL" :tabindex="14">
				</div> 
	        </div>
	        <div class="col-12 col-lg-4 mb-1">
	            <label class="form-label text-danger mb-1">Cod. Fiscale:</label>
				<div class="input-group">
					<span class="input-group-text"><i class="far fa-barcode fa-fw"></i></span>
					<input autocomplete="off" type="text" class="form-control form-control-sm" v-model="persona.CODICE_FISCALE" :tabindex="16">
				</div> 	        	
			</div>
	    </div>
		<div class="row" v-show="modalita == 2">
 
			<form action="#" v-if="persona.ID_PERSONA_FISICA > 0">
				<fieldset>
					<legend class="fs-base fw-bold border-bottom pb-2 mb-3"><i class="ph-info me-2"></i>Anagrafica</legend>	
					<div class="row mb-1">
						<div class="col-6 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext" style="border-bottom: 1px dashed #ccc;"> {{ persona.NOME }} </div>
								<label class="fs-sm">NOME</label>
							</div>
						</div>
						<div class="col-6 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext" style="border-bottom: 1px dashed #ccc;"> {{ persona.COGNOME }} </div>
								<label class="fs-sm">COGNOME</label>
							</div>
						</div>
						<div class="col-5 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext text-uppercase" style="border-bottom: 1px dashed #ccc;"><Flag :country="persona.FK_ID_NAZIONALITA" class="rounded me-2"></Flag>{{ persona.nazionalita.NOME }}  </div>
								<label class="fs-sm">NAZIONALITÀ</label>
							</div>
						</div>
					
						<div class="col-7 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext text-uppercase" v-if="persona.comuneNascita != null"  style="border-bottom: 1px dashed #ccc;"> {{ persona.comuneNascita.NOME }} </div>
								<label class="fs-sm">NATA A</label>
							</div>
						</div>
						<div class="col-5 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext" style="border-bottom: 1px dashed #ccc;"> {{ persona.DATA_NASCITA }} </div>
								<label class="fs-sm">IL</label>
							</div>
						</div>
						<div class="col-7 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext text-uppercase" style="border-bottom: 1px dashed #ccc;"> {{ persona.CODICE_FISCALE }} </div>
								<label class="fs-sm">CODICE FISCALE</label>
							</div>
						</div>
					
						<div class="col-12 col-lg-6">
							<div class="form-floating">
								<div class="form-control-plaintext text-uppercase" style="border-bottom: 1px dashed #ccc;"> {{ persona.INDIRIZZO }} N {{ persona.CIVICO }} </div>
								<label class="fs-sm">INDIRIZZO RESIDENZA</label>
							</div>
						</div>
						<div class="col-5 col-lg-2">
							<div class="form-floating">
								<div class="form-control-plaintext" style="border-bottom: 1px dashed #ccc;"> {{ persona.CAP }} </div>
								<label class="fs-sm">CAP</label>
							</div>
						</div>
						<div class="col-7 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext text-uppercase" v-if="persona.comuneResidenza != null" style="border-bottom: 1px dashed #ccc;"> {{ persona.comuneResidenza.NOME }} <small>({{ persona.PROV }})</small></div>
								<label class="fs-sm">CITTÀ</label>
							</div>
						</div>
					
						<div class="col-12 col-lg-6">
							<div class="form-floating">
								<div class="form-control-plaintext text-lowercase" style="border-bottom: 1px dashed #ccc;"> {{ persona.EMAIL }} </div>
								<label class="fs-sm">EMAIL</label>
							</div>
						</div>
						<div class="col-7 col-lg-4">
							<div class="form-floating">
								<div class="form-control-plaintext" style="border-bottom: 1px dashed #ccc;"> {{ persona.TELEFONO }} </div>
								<label class="fs-sm">TELEFONO</label>
							</div>
						</div>
						<div class="col-5 col-lg-2">
							<div class="form-floating">
								<div class="form-control-plaintext" style="border-bottom: 1px dashed #ccc;"> {{ persona.SDI }} </div>
								<label class="fs-sm">SDI</label>
							</div>
						</div>
					</div>


				</fieldset>
			</form>


		</div>
		

</template>



<script>
import { computed } from 'vue'
import Select2 from '@/components/utils/Select2.vue'
//import VueDatePicker from '@vuepic/vue-datepicker'
import Flag from '@/components/utils/Flag.vue'




export default {
    name: 'PersonaFisica',
	
    components:{
        Select2,
        //VueDatePicker,
		Flag,
    },
    props: {
		modelValue: {
			type: Object,
			default: () => ({}),
		},
		modalita:{
			type: Number,
			default: 1
		}
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const persona = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });
        return { persona };
    },
    data:function(){
        return{
            
        }
    },
    methods: {
        setCap(item){
            this.persona.CAP = item.CAP;
        },
		handlerChangeResidenza : function(val){	
			if (val > 0){
				utils.ajax("core/geo/comune",{ID_COMUNE:val}, (response) => {
					this.persona.PROV = response.data.provincia.DESC_BREVE;
					this.setCap(response.data);
				},false);	
			}		
		},
		
    },
    computed: {
    
    },
    watch: {
        
    },
}

</script>
